const LockerCardSchedule = () => (
  <div className="flex gap-[4px]">
    Luni - Duminica: <div className="text-[#319D10] font-medium">Non-stop</div>
  </div>
);

export default LockerCardSchedule;
